import React from "react";
import { PropTypes } from "prop-types";
import { useSelector } from "react-redux";
import PaymentStatement from "./PaymentStatement";
import PaymentAlternative from "./PaymentAlternative";

const PaymentAdditional = ({
  user = {},
  hideAutopayDescription,
  className,
}) => {
  const { roles } = useSelector((state) => state.user);
  const hasLink = !!user.alternative_payment_link;
  // const showAlternativePay = (user.delinquent && user.payment_due_balance < 0) ||
  //   !!roles.user_terminated_with_balance;
  const showAlternativePay = true;

  return showAlternativePay ? (
    hasLink && <PaymentAlternative
      user={user}
      className={className}
    />
  ) : (
    <PaymentStatement
      user={user}
      className={className}
      hideAutopayDescription={hideAutopayDescription}
    />
  );
};

PaymentAdditional.propTypes = {
  user: PropTypes.shape({
    delinquent: PropTypes.bool,
    payment_due_balance: PropTypes.number,
    alternative_payment_link: PropTypes.string,
  }).isRequired,
  hideAutopayDescription: PropTypes.bool,
  className: PropTypes.string,
};

PaymentAdditional.defaultProps = {
  hideAutopayDescription: false,
  className: "",
};

export default PaymentAdditional;
